import { useQuery } from 'react-query';

import { getEnergyAnalysis } from '../services/api';
import { queryKeys } from '../utils/react-query';

export const useEnergyAnalysis = (registrationId: string | undefined) => {
  const { data, isLoading, isError, error } = useQuery(
    [queryKeys.energyAnalysis, registrationId],
    () => getEnergyAnalysis(registrationId),
    {
      enabled: !!registrationId,
      refetchOnWindowFocus: true
    }
  );

  const energyAnalysis = data?.[0];

  return {
    energyAnalysis,
    energyAnalysisLoading: isLoading,
    energyAnalysisError: isError && !data ? error : null
  };
};
